import React from 'react';
import styled from 'styled-components';
import { Button } from '../../UI/Buttons';
import { Overlay, Modal } from '../../UI/Containers';
import { Title } from '../../UI/Typography';

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
`;
const HeaderBorder = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  margin-left:  16px; /* Controls the width of the border */
  margin-right: 16px; /* Controls the width of the border */
  margin-top: 5px; 
`;
const CloseButton = styled(Button)`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSizes.xl};
  padding: ${({ theme }) => theme.spacing.xs};
  line-height: 1;
  border: none;
  min-width: 32px;
  min-height: 32px;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: transparent;
  }
`;

const ModalBody = styled.div`
  padding: 16px;
  // flex-grow: 1;
  overflow-y: auto;
`;

const FullScreenModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <Overlay opacity={0.7} onClick={onClose}>
      <Modal maxWidth="100%" onClick={e => e.stopPropagation()}> {/* made maxwidth 100% */}
        <ModalHeader>
          <Title as="h2" style={{ margin: 0, fontSize: '1.3em',padding:0 }}>Site Registration</Title>
          <CloseButton onClick={onClose} aria-label="Close Modal">×</CloseButton>
        </ModalHeader>
        <HeaderBorder />
        <ModalBody>
          {children}
        </ModalBody>
      </Modal>
    </Overlay>
  );
};

export default FullScreenModal;
